import { isInvalidPurchaseOrderNumber } from "src/validation/stringValidation";
import { isInvalidISODate, isDateTodayOrInTheFuture } from "src/helpers/dateHelper";
import { FormValidator } from "../formValidator";
import { ValidationError, ValidationErrors } from "src/errors";
import { ResolveGXOErrorFormDataKey } from "src/types/forms/purchaseOrders/resolveGXOErrorForm";

class ResolveGXOErrorFormValidator extends FormValidator {
  private static validatePurchaseOrderNumber(value: unknown): ValidationError<"purchaseOrderId"> | undefined {
    return isInvalidPurchaseOrderNumber(value)
      ? new ValidationError("Enter a valid purchase order number (e.g., 'PO-2055')", "purchaseOrderId")
      : undefined;
  }

  private static validateEstimatedDeliveryDate(value: unknown): ValidationError<"estimatedDeliveryDate"> | undefined {
    if (!value || typeof value !== "string" || value.trim() === "") {
      return new ValidationError("Estimated delivery date is required", "estimatedDeliveryDate");
    }

    if (isInvalidISODate(value)) {
      return new ValidationError("Enter a valid date (example format: '2026-01-01')", "estimatedDeliveryDate");
    }

    if (!isDateTodayOrInTheFuture(value)) {
      return new ValidationError("Estimated delivery date must be today or in the future", "estimatedDeliveryDate");
    }

    return undefined;
  }

  private static readonly validationStrategies: Record<
    ResolveGXOErrorFormDataKey,
    (inputValue: unknown) => ValidationError<ResolveGXOErrorFormDataKey> | undefined
  > = {
    purchaseOrderId: ResolveGXOErrorFormValidator.validatePurchaseOrderNumber,
    estimatedDeliveryDate: ResolveGXOErrorFormValidator.validateEstimatedDeliveryDate
  };

  static validateResolveGXOErrorFormData<T extends ResolveGXOErrorFormDataKey>(
    formData: Partial<Record<T, unknown>>
  ): ValidationErrors<T> {
    return super.validateFormData(formData, ResolveGXOErrorFormValidator.validationStrategies) as ValidationErrors<T>;
  }
}

export { ResolveGXOErrorFormValidator };
